"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const cell_1 = __importDefault(require("../cell"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('input');
const AInput = (props) => {
    const { label, name, type, value, className = '', inputAlign, placeholder, onChange, disabled, border = true, required, icon, extra, maxLength, cellStyle, } = props;
    const handleChangeInput = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    const inputElement = (React.createElement(one_1.Input, { className: classnames_1.default({
            [prefixCls]: true,
            [`${prefixCls}-align-right`]: inputAlign === 'right',
            [`${prefixCls}-align-center`]: inputAlign === 'center',
            [className]: true,
        }), name: name, type: type, value: value, placeholder: placeholder, onInput: handleChangeInput, disabled: disabled, maxLength: maxLength }));
    return (React.createElement(cell_1.default, { style: cellStyle, label: label, labelStyle: { width: '180px' }, border: border, required: required, icon: icon, field: true },
        React.createElement(one_1.View, { className: `${prefixCls}-container` },
            inputElement,
            extra && React.createElement(one_1.View, { className: `${prefixCls}-extra` }, extra))));
};
exports.default = AInput;
